import React from "react";
import LoadingImg from "../assets/images/loading.png";

export default ({ show = true }) => {
	return (
		<div className={`preloader ${show ? "show" : ""}`}>
			<img src={LoadingImg} alt="Loading..." />
		</div>
	);
};
